import React, { Component } from "react";
import { connect } from "react-redux";
import getConfig from "next/config";
const {
  publicRuntimeConfig: {
    settings: { websiteName },
  },
} = getConfig();

import ContentEditorView from "@components/ContentEditorView/index";
import Alert from "@components/Alert";
import Button from "@components/Button";
import Heading from "@components/Heading";

class DonationForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      donation: "",
      altaSuma: false,
      altaSumaValidation: false,
    };
  }

  donationSubmit = async () => {
    const { donation } = this.state;
    if (!(donation > 0)) {
      this.setState({
        altaSumaValidation:
          "Te rugam sa alegi o suma sau sa introduci o valoare numerica mai mare ca 0.",
      });
    } else {
      this.setState({
        altaSumaValidation: false,
      });
      this.props.addDonationToCart(donation);
    }
  };

  render() {
    const { donationSums, layout, donationInfo } = this.props;
    const { altaSuma, altaSumaValidation, donation } = this.state;

    if (!(websiteName === "altex" && donationSums && donationSums.length > 0))
      return null;

    return (
      <div
        className={layout === "cart" ? "md:flex my-4 border rounded p-6" : ""}
      >
        {layout === "cart" && donationInfo && (
          <div className="w-full mx-auto sm:w-9/12 md:w-6/12 p-2 md:p-6 text-sm leading-normal sm:leading-loose mb-8 md:mb-0">
            <ContentEditorView content={donationInfo} />
          </div>
        )}
        <div
          className={
            layout === "cart"
              ? "w-full mx-auto sm:w-9/12 md:w-6/12 md:px-5 md:py-6"
              : "w-full px-8 mb-6"
          }
        >
          <Heading
            display="h2"
            as="h2"
            title="Alege suma pe care doresti sa o donezi"
            classesProp="text-center"
          />
          <h3 className={`mb-2 mt-0 mx-2`}></h3>

          <div className="flex -mx-2">
            {!!donationSums &&
              donationSums.map((s) => (
                <button
                  key={s}
                  className={`
                  flex items-center justify-center w-full m-2 p-2 text-lg rounded-tr-lg rounded-bl-lg outline-none border-primary border-2
                  ${!altaSuma && donation === s ? "bg-primary" : ""}
                `}
                  onClick={() =>
                    this.setState({ donation: s, altaSuma: false })
                  }
                >
                  {`${s} lei`}
                  {!altaSuma && donation === s && (
                    <svg
                      className="ml-1"
                      width="13"
                      height="13"
                      viewBox="0 0 13 13"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M2.12132 8.24263L4.76831 11.1037C4.96101 11.312 5.28823 11.3184 5.48888 11.1177L11.4853 5.12131"
                        stroke="black"
                        strokeWidth="2"
                        strokeLinecap="round"
                      />
                    </svg>
                  )}
                </button>
              ))}
          </div>
          <div className="w-full mb-4">
            <button
              className={`
                block w-full my-2 p-2 text-lg rounded-tr-lg rounded-bl-lg outline-none border-primary border-2
                ${altaSuma === true ? "bg-primary" : ""}
              `}
              onClick={() => this.setState({ altaSuma: true, donation: "" })}
            >
              Alta suma
            </button>
          </div>
          {altaSuma && (
            <div className="mb-4">
              <input
                type="text"
                value={donation}
                inputMode="numeric"
                pattern="[0-9]*"
                className={`Form-input Form-wide text-black ${
                  altaSumaValidation ? "error" : ""
                }`}
                placeholder="Introdu suma dorita"
                onChange={(e) => {
                  {
                    /* console.log(e.target.value); */
                  }
                  const parsed = parseInt(e.target.value, 10);
                  if (!isNaN(parsed)) {
                    if (parsed < 50001) {
                      this.setState({ donation: parsed });
                    }
                  } else {
                    this.setState({ donation: "" });
                  }
                }}
              />
            </div>
          )}

          {!!altaSumaValidation && (
            <div className="my-2">
              <Alert>
                <span>{altaSumaValidation}</span>
              </Alert>
            </div>
          )}

          <div className={`mx-2 text-center text-red-brand`}>
            <small>Donatiile se pot face doar cu cardul, online.</small>
          </div>

          <div className="mt-4">
            {layout === "cart" ? (
              <Button
                title="Adauga donatia in cos"
                display="block"
                size="normal"
                variant="primary"
                onClick={this.donationSubmit}
              />
            ) : (
              <button
                className="leading-none rounded active:outline-none text-usm text-white active:opacity-75 group w-full block bg-secondary"
                type="button"
                style={{ backgroundColor: "#c00033" }}
                onClick={this.donationSubmit}
              >
                <div className="">
                  <div className="border-2 rounded p-1 border-transparent">
                    <div
                      className="flex items-center justify-center"
                      style={{ minHeight: "2em" }}
                    >
                      Adauga donatia in cos
                    </div>
                  </div>
                </div>
              </button>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default connect((state) => ({
  donationInfo: state.app.cmsObjBlocks.donatie_checkout_info_new,
}))(DonationForm);
